export const color = {
  black: "#000000",
  white: "#ffffff",
  separatorGrey: "#cccccc",
  navyBlue: "#15232F",
  menuGrey: "#8e8e8e"
}
